var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSwapTickSuccess = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.784 3.33325H27.234C32.884 3.33325 36.6673 7.29992 36.6673 13.1999V26.8183C36.6673 32.6999 32.884 36.6666 27.234 36.6666H12.784C7.13398 36.6666 3.33398 32.6999 3.33398 26.8183V13.1999C3.33398 7.29992 7.13398 3.33325 12.784 3.33325ZM19.0507 24.9833L26.9673 17.0666C27.534 16.4999 27.534 15.5833 26.9673 14.9999C26.4007 14.4333 25.4673 14.4333 24.9007 14.9999L18.0173 21.8833L15.1007 18.9666C14.534 18.3999 13.6007 18.3999 13.034 18.9666C12.4673 19.5333 12.4673 20.4499 13.034 21.0333L17.0007 24.9833C17.284 25.2666 17.6507 25.3999 18.0173 25.3999C18.4007 25.3999 18.7673 25.2666 19.0507 24.9833Z",
    fill: "#08CD1F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwapTickSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap-tick-success.482489cc.svg";
export { ForwardRef as ReactComponent };